import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useConfig } from '../auth'
import { safeReturnPath, startMicrosoftLogin } from '../lib/sso'
import { Alert, Button, Card, Spin, Typography } from 'antd'

const { Title, Text } = Typography

export default function Login() {
  const config = useConfig()
  const location = useLocation()
  const hasMicrosoft = config.data.socialaccount?.providers?.some(provider => provider.id === 'microsoft')
  const params = new URLSearchParams(location.search)
  const next = safeReturnPath(params.get('next'))
  const manual = params.has('logged_out') || params.has('error')
  const redirectStarted = useRef(false)

  useEffect(() => {
    if (hasMicrosoft && !manual && !redirectStarted.current) {
      redirectStarted.current = true
      startMicrosoftLogin(next)
    }
  }, [hasMicrosoft, manual, next])

  if (hasMicrosoft && !manual) {
    return (
      <div role='status' style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16 }}>
        <Spin size='large' />
        <Text type='secondary'>Logging you in...</Text>
      </div>
    )
  }

  return (
    <div style={{ maxWidth: 380, margin: '48px auto' }}>
      <Card>
        <Title level={2} className='tti-page-title' style={{ marginBottom: 4 }}>Login</Title>

        <div style={{ marginTop: 20 }}>
          {hasMicrosoft
            ? (
              <>
                {params.has('error') && <Alert type='error' showIcon title='Microsoft sign-in failed. Please try again or contact IT.' />}
                <Button block onClick={() => startMicrosoftLogin(next)} style={{ marginTop: params.has('error') ? 16 : 0 }}>Microsoft Single Sign-On</Button>
              </>
            )
            : (
              <Alert type='error' showIcon title='Microsoft sign-in is unavailable. Contact IT for assistance.' />
            )}
        </div>
      </Card>
    </div>
  )
}
